import { useEffect, useState } from "react";
import { getRuntimeConfig } from "../../Lib/Config/RuntimeConfig";

/**
 * True only when NEXT_PUBLIC_ENABLE_CORPORATE === "true". Defaults to false so
 * corporate entry points stay hidden until the config says otherwise. The
 * routes themselves are gated server-side by their layouts.
 */
export function useCorporateEnabled(): boolean {
    const [isEnabled, setIsEnabled] = useState(false);

    useEffect(() => {
        let cancelled = false;
        getRuntimeConfig()
            .then((config) => {
                if (!cancelled) setIsEnabled(config?.NEXT_PUBLIC_ENABLE_CORPORATE === "true");
            })
            .catch(() => {
                if (!cancelled) setIsEnabled(false);
            });
        return () => {
            cancelled = true;
        };
    }, []);

    return isEnabled;
}
